export function base64toBlob(base64Data, contentType) {
  let blobContentType = contentType || "";
  const sliceSize = 1024;
  const byteCharacters = window.atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }

  return new Blob(byteArrays, { type: blobContentType });
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function bytesToSize(bytes) {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

  if (bytes === 0) {
    return "0 Byte";
  }

  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);

  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

/* Returns backend allowed mime type constants */
export function getFileTypeFromMimeType(type) {
  switch (type) {
    case "application/pdf":
      return "APPLICATION_PDF";

    case "image/png":
      return "IMAGE_PNG";

    case "image/jpeg":
      return "IMAGE_JPEG";

    case "image/jpg":
      return "IMAGE_JPG";

    case "image/tiff":
      return "IMAGE_TIFF";

    case "image/gif":
      return "IMAGE_GIF";

    default:
      return "";
  }
}
